import { __read, __spreadArray } from "tslib";
import { ALLOW_PREDEFINED_VALUES, assertsValidAllow } from '../constant';
var whiteSpaces = /\s+/g;
var whiteSpaceOrSemicolon = /(\s+|;+)/g;
var whiteSpaceOrSemicolonReplacer = function (match) {
    if (whiteSpaces.test(match)) {
        return '';
    }
    return ';';
};
export var getAllowArray = function (value) {
    if (!value) {
        return [];
    }
    var processedValue = value.trim().toLocaleLowerCase();
    var allowArr = processedValue
        .replace(whiteSpaceOrSemicolon, whiteSpaceOrSemicolonReplacer)
        .split(';')
        .filter(Boolean);
    allowArr.forEach(assertsValidAllow);
    return allowArr;
};
export var getAllowFromArray = function (list) {
    return Array.from(new Set(list)).join('; ');
};
export var getAllow = function (allow) {
    if (!allow) {
        return getAllowFromArray(ALLOW_PREDEFINED_VALUES);
    }
    var allowArr = getAllowArray(allow);
    return getAllowFromArray(__spreadArray(__spreadArray([], __read(allowArr), false), __read(ALLOW_PREDEFINED_VALUES), false));
};
export var testUtils = {
    isAllowIncludesPredefinedValues: function (allow) {
        return ALLOW_PREDEFINED_VALUES.every(function (val) { return allow.includes(val); });
    }
};
